import { hubsMultiSelectIntlIds } from './hubs-multi-select.ids';

export const hubsMultiSelectLangEsMx = {
  [hubsMultiSelectIntlIds.allValuesLabel]: 'Todos los hubs',
  [hubsMultiSelectIntlIds.placeholder]: 'Seleccione uno o más hubs',
  [hubsMultiSelectIntlIds.noOptionsLabel]: 'No hay opciones disponibles',
};
